import React, { useEffect, useState } from "react";
import MaterialTable from 'material-table';
import { useForm } from 'react-hook-form';
import Select from 'react-select'

// reactstrap components
import {
    Card,
    CardBody,
    CardHeader,
    Collapse,
    Form,
    Row,
    Col,
    Input,
    Button,
    FormGroup
} from "reactstrap";

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// services
import { showMessage } from "../../services/message.js";
import { api_GET, api_POST, api_PUT } from "../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "../../services/acesso.js";
import { InputHourMinutes } from "../../services/mask.js";
import { isValidHourMinute } from "../../helpers/valid.js";

//Context
import { useAuth } from "../../context/auth.js";

export default function CadastroSetupAgendaVistoria({ history }) {
    const {session, setLoading} = useAuth();

    const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });
    const [permiteEditar, set_permiteEditar] = useState(false);

    const [horarioInicio, set_horarioInicio] = useState(null);
    const handleChangeHorarioInicio = (event) => {
        set_horarioInicio(event.target.value);
        clearErrors("horarioInicio");
    }

    const [horarioTermino, set_horarioTermino] = useState(null);
    const handleChangeHorarioTermino = (event) => {
        set_horarioTermino(event.target.value);
        clearErrors("horarioTermino");
    }

    const [diaSemana, set_diaSemana] = useState(null);
    const [options_diaSemana] = useState([
        { value: "Segunda", label: "Segunda" },
        { value: "Terça", label: "Terça" },
        { value: "Quarta", label: "Quarta" },
        { value: "Quinta", label: "Quinta" },
        { value: "Sexta", label: "Sexta" },
        { value: "Sábado", label: "Sábado" },
        { value: "Domingo", label: "Domingo" },
    ]);
    const handleDiaSemana = (value) => {
        set_diaSemana(value);
        setValue("diaSemana", value, true);
        clearErrors("diaSemana");
    }

    const [rowEdit, set_rowEdit] = useState(null);
    const [openCollapse, set_openCollapse] = useState(false);
    const [list_table, set_list_table] = useState([]);

    const loadList = () => {
        set_openCollapse(false);
        set_rowEdit(null);
        setLoading(true);
        api_GET('setupAgendaVistoria')
            .then(result => set_list_table(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleAdd = () => {
        set_rowEdit(null);
        set_diaSemana(null);
        setValue("diaSemana", null, false);
        set_horarioInicio("");
        set_horarioTermino("");
        setValue("capacidadeDiaria", "");
        setValue("duracaoVistoriaMinutos", "");
        set_openCollapse(true);
    }

    const handleEdit = (rowData) => {
        clearErrors();
        set_rowEdit(rowData);
        set_diaSemana(rowData.diaSemana);
        setValue("diaSemana", rowData.diaSemana, true);
        set_horarioInicio(rowData.horarioInicio);
        set_horarioTermino(rowData.horarioTermino);
        setValue("capacidadeDiaria", rowData.capacidadeDiaria);
        setValue("duracaoVistoriaMinutos", rowData.duracaoVistoriaMinutos);
        set_openCollapse(true);
    }

    const onSubmit = (data) => {
        let setupAgendaVistoria_Id = rowEdit ? rowEdit.setupAgendaVistoria_Id : 0;
        if (list_table.filter(f => f.diaSemana == diaSemana && f.setupAgendaVistoria_Id != setupAgendaVistoria_Id).length > 0) {
            showMessage("Aviso", "Este dia da semana já está configurado. Edite a configuração!", 'error', null, null);
            return;
        }

        if (!isValidHourMinute(data.horarioInicio) || !isValidHourMinute(data.horarioTermino)) {
            showMessage("Aviso", "Horário inválido!", 'error', null, null);
            return;
        }

        let json_submit = {
            setupAgendaVistoria_Id: setupAgendaVistoria_Id,
            diaSemana: diaSemana,
            horarioInicio: data.horarioInicio,
            horarioTermino: data.horarioTermino,
            capacidadeDiaria: data.capacidadeDiaria,
            duracaoVistoriaMinutos: data.duracaoVistoriaMinutos,
            usuarioUltimaAlteracao_Id: session.usuario_Id
        }
        setLoading(true);
        if (json_submit.setupAgendaVistoria_Id == 0) {
            api_POST('setupAgendaVistoria', json_submit)
                .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { loadList() }))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
        else {
            api_PUT('setupAgendaVistoria', json_submit)
                .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { loadList() }))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }

    useEffect(() => {
        ValidaAcessoFuncionalidadeAcao("SetupAgenda.Editar", function (result) { set_permiteEditar(result) });
        loadList();
    }, []);


    return (
        <>
            <div className="content">
                <button type="button" disabled={!permiteEditar} onClick={handleAdd} className="btn btn-secundary"><i className="fa fa-plus"></i>  Nova Agenda</button>
                <Collapse isOpen={openCollapse} defaultOpen={false}>
                    <Row>
                        <Col md="12">
                            <Card className="card-user">
                                <CardHeader>
                                    <Row><Col md="12" className="text-right"><label className="text-danger">* Campos Obrigatórios</label></Col></Row>
                                </CardHeader>
                                <CardBody style={{ minHeight: "auto" }}>
                                    <Form style={{ maxWidth: "95%", margin: "0 auto" }} onSubmit={handleSubmit(onSubmit)}>
                                        <Row>
                                            <Col md="4" sm="4">
                                                <FormGroup>
                                                    <b><label><span className="text-danger">*</span> Dia da Semana</label></b>
                                                    <Select
                                                        options={options_diaSemana}
                                                        name="status"
                                                        getOptionLabel={({ label }) => label}
                                                        getOptionValue={({ value }) => value}
                                                        onChange={(e) => { handleDiaSemana(e.value) }}
                                                        value={diaSemana && options_diaSemana.find(obj => obj.value === diaSemana)}
                                                        placeholder="Selecione"
                                                        ref={e => register(
                                                            { name: "diaSemana" },
                                                            { required: true })
                                                        }
                                                    />
                                                    {errors.diaSemana && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col md="4" sm="4">
                                                <FormGroup>
                                                    <b><label><span className="text-danger">*</span> Horário de Início</label></b>
                                                    <InputHourMinutes value={horarioInicio} onChange={handleChangeHorarioInicio} name="horarioInicio" inputRef={register({ required: true })} />
                                                    {errors.horarioInicio && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col md="4" sm="4">
                                                <FormGroup>
                                                    <b><label><span className="text-danger">*</span> Horário de Término</label></b>
                                                    <InputHourMinutes value={horarioTermino} onChange={handleChangeHorarioTermino} name="horarioTermino" inputRef={register({ required: true })} />
                                                    {errors.horarioTermino && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col md="4" sm="4">
                                                <FormGroup>
                                                    <b><label><span className="text-danger">*</span> Capacidade Diária</label></b>
                                                    <Input type="number" name="capacidadeDiaria" innerRef={register({ required: true })} />
                                                    {errors.capacidadeDiaria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col md="4" sm="4">
                                                <FormGroup>
                                                    <b><label><span className="text-danger">*</span> Duração Vistoria (Minutos)</label></b>
                                                    <Input type="number" name="duracaoVistoriaMinutos" innerRef={register({ required: true })} />
                                                    {errors.duracaoVistoriaMinutos && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                </FormGroup>
                                            </Col>
                                            <Col className="text-center" md="12" sm="12">
                                                <FormGroup>
                                                    <Button color="success" disabled={!permiteEditar} type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Collapse>
                <Row>
                    <Col md="12">
                        <MaterialTable style={{ minHeight: "auto" }}
                            title=""
                            columns={[
                                { title: 'Dia da Semana', field: 'diaSemana' },
                                { title: 'Horário Início', field: 'horarioInicio' },
                                { title: 'Horário Término', field: 'horarioTermino' },
                                { title: 'Capacidade Diária', field: 'capacidadeDiaria', type: 'numeric', cellStyle: { textAlign: "right" } },
                                { title: 'Duração (min)', field: 'duracaoVistoriaMinutos', type: 'numeric', cellStyle: { textAlign: "right" } },
                            ]}
                            data={list_table}
                            isLoading={false}
                            options={{
                                ...table_style,
                                filtering: false,
                                exportButton: true
                            }}
                            actions={[
                                {
                                    icon: 'edit',
                                    tooltip: 'Editar Registro',
                                    onClick: (event, rowData) => handleEdit(rowData)
                                }
                            ]}
                            localization={table_translate}
                        />
                    </Col>
                </Row>
            </div>
        </>
    );

}
